{
  "version": 1,
  "asset_id": "518ff153-900a-450e-9400-1cc45cfe673b",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/518ff153-900a-450e-9400-1cc45cfe673b/homosassa-blue-metal-roof-installation-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/518ff153-900a-450e-9400-1cc45cfe673b/homosassa-blue-metal-roof-installation-1200w.webp",
  "original_filename": "homosassa-blue-metal-roof-installation-1200w.webp",
  "size": 111340,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
